import React from 'react';
import I18n from '@/modules/i18n';
import cn from '@/utils/cn';
import { IText } from 'fabric';
import Action from '../Action';
import { handleBoldText, handleItalicText } from '../actions';
import useDrawingContext from '../../store/useDrawingContext';

const TextActions = () => {
  const canvas = useDrawingContext(state => state.canvas);
  const activeObject = (canvas.getActiveObject() as IText);
  const isBold = activeObject?.fontWeight === 'bold';

  return (
    <>
      <Action
        className={cn(
          'fa fa-bold tw-w-[35px]',
          { 'tw-bg-gray-100': isBold },
        )}
        tooltipContent={I18n.t('bold')}
        onClick={() => handleBoldText(canvas)}
      />
      <Action
        className={cn(
          'fa fa-italic tw-w-[35px] tw-mr-2',
          { 'tw-bg-gray-100': activeObject?.fontStyle === 'italic' },
        )}
        tooltipContent={I18n.t('italic')}
        onClick={() => handleItalicText(canvas)}
      />
    </>
  );
};

export default TextActions;
